const Constants = {
    Storage : {
        reportMeta: 'reportMeta'
    }
};

export default class SessionStorage {

    static setReportMeta(value: Object) {
        sessionStorage.setItem(Constants.Storage.reportMeta, JSON.stringify(value));
    }

    static getReportMeta() {
        var data = sessionStorage.getItem(Constants.Storage.reportMeta);
        return data ? (JSON.parse(data)) : undefined;
    }

    static clearReportMeta() {
        sessionStorage.removeItem(Constants.Storage.reportMeta);
    }
}


// WEBPACK FOOTER //
// ./src/service/sessionstorage.ts